import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

import CloseIcon from '@material-ui/icons/Close'

import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'

import '../filesMenu.css'

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    width: 120,
    margin: 'auto',
    '& .MuiOutlinedInput-root': {
      height: 37,
    },
    '& .MuiSelect-outlined': {
      height: 37,
    },
    '& .MuiSelect-select': {
      height: 37,
    },
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
}))

function DownloadModal(props) {
  const [folderName, setFolderName] = useState('')

  const classes = useStyles()

  const changeName = (event) => {
    const { value } = event.target
    setFolderName(value)
  }

  const addFolder = () => {
    if (folderName.trim() !== '') {
      props.setProjects((prevState) => {
        return [
          ...prevState,
          { project_id: uuidv4(), projectName: folderName, visible: true, active: true, height: true, s3: false },
        ]
      })
      props.setProject(folderName)
      props.setAddModal(false)
    }
  }

  return (
    <div className="save-file-modal">
      <IconButton size="small" component="span" onClick={() => props.handleCloseModal()} className="sf-modal-close">
        <CloseIcon />
      </IconButton>
      <h3>Add Folder</h3>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '15px' }}>
        <div style={{ display: 'flex' }}>
          <label style={{ height: 'fit-content', marginRight: '10px', alignSelf: 'center' }}>Folder Name:</label>
          <TextField
            id="filled-name"
            size="small"
            // style={{ width: '100%' }}
            variant="outlined"
            value={folderName}
            onChange={changeName}
          />
        </div>

        <button
          className="files-manager-btn ripple"
          style={{ width: '140px', margin: 'auto', display: 'block' }}
          onClick={() => addFolder()}
        >
          ADD
        </button>
      </div>
    </div>
  )
}

export default DownloadModal
